<template>
    <Popup v-model="open">
      <template #content>
        <div id="share_page">
            <div class="inner">

                <h3>שיתוף באמצעות:</h3>

                <div>
                    <a class="soci_ico fb normal_link" :href="'https://www.facebook.com/sharer/sharer.php?u=' + share_url" target="_blank"></a>
                    <a class="soci_ico twitter normal_link" :href="'https://twitter.com/share?url=' + share_url" target="_blank"></a>
                    <!-- <a class="email normal_link"></a> -->
                    <a class="soci_ico whatsapp normal_link" :href="'whatsapp://send?text=' + share_url"></a>
                </div>
                
                <div style="padding-top: 20px;"><label>כתובת לשיתוף:</label><input type="text" style="text-align: center;" id="txt_share_url" ref="textShare" :value="share_url" @focus="copyUrl"></div>	
            </div>
        </div>
      </template>

       <template #actions>
        <a class="md-primary" @click="close">סגירה</a> 
      </template>
    </Popup>

</template>

<script>


export default {  
    
    data(){
        return {
          share_url: '',
          open:false,
        };
    },

    mounted(){
      this.$bus.$on('share_url', (item) => { 
        this.share_url=item; 
        this.open = true;
      });
      
    },

    computed:{
        showDialog(){
          return (this.share_url != '');
        }
    },

    methods: {
      close(){
        this.open=false;
      },
      copyUrl(){
        this.$refs.textShare.select();
        document.execCommand('copy');
        this.alert('כתובת העמוד הועתקה ללוח')
      }
  }

}
</script>

<style lang="scss" scoped>
#share_page{ text-align: center; padding:40px;

    h3 { margin-bottom: 20px; }

    .soci_ico { display: inline-block; width: 50px; height: 50px; border-radius: 100%; color: #fff; margin: 0 15px; line-height: 148px; background: center center no-repeat; background-size: 80%; }

    #txt_share_url { border: none; border-bottom: 1px solid #eee; width:100%; outline: none; height: 40px; font-size: 16px;
    &:focus { border-bottom: 3px solid #000;}}

}
</style>